export default __webpack_public_path__ + "static/e-commerce-loss-8252e5cc38ead398c31dd6f21343a694.jpg";